// Verbatim string the backend returns for both mid-session (auth middleware)
// and login-time (admin controller) deactivation checks — see
// tecnogex_new_backend src/middlewares/auth.middleware.js and
// src/controllers/admin.controllers.js. There's no dedicated error code for
// this on the backend, and 403 is reused for other permission failures too,
// so matching on this exact message is currently the only reliable signal.
export const DEACTIVATED_MESSAGE =
  'This account has been deactivated. Contact an administrator.';

export const StatusCode = {
  NotFound: 404,
  Forbidden: 403,
  BadRequest: 400,
  UpgradeRequired: 426,
  ManyRequest: 429,
  ServerError: 500,
  UnAuthorized: 401,
  ExpressErrors: 422,
  Success: 200,
  Created: 201,
  Error: 'error',
  NetworkError: 'Network Error',
};

const {
  REACT_APP_IS_STAGE,
  REACT_APP_IS_PRODUCTION,
  REACT_APP_STAGE_ENDPOINT,
  REACT_APP_PRODUCTION_ENDPOINT,
  REACT_APP_LOCAL_ENDPOINT,
} = process.env;

// Convert the environment variables to booleans
const isStage = Number(REACT_APP_IS_STAGE) === 1;
const isProduction = Number(REACT_APP_IS_PRODUCTION) === 1;

// Determine the endpoint based on the environment flags
export const ENDPOINT = (() => {
  if (isStage) {
    return REACT_APP_STAGE_ENDPOINT;
  } else if (isProduction) {
    return REACT_APP_PRODUCTION_ENDPOINT;
  } else {
    return REACT_APP_LOCAL_ENDPOINT;
  }
})();
